// Budget Reizen data

export const budgetReizen = {
  europa: [
    {
      id: 'italie',
      naam: 'Italië',
      dagen: 12,
      prijs: 700,
      hoogtepunten: ['🏛️ Colosseum Bezoeken', '🍕 Authentieke Pizza', '🎨 Renaissance Kunst', '🌊 Amalfi Kust'],
      beschrijving: 'Rome, Florence, Pisa, Napoli, Amalfi Kust',
      image_url: 'https://images.unsplash.com/photo-1499678329028-101435549a4e?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'griekenland',
      naam: 'Griekenland',
      dagen: 14,
      prijs: 800,
      hoogtepunten: ['🏛️ Acropolis Verkennen', '🏝️ Santorini Zonsondergang', '🍷 Griekse Tavernes', '🏖️ Eiland Hoppen'],
      beschrijving: 'Athene, Santorini, Paros, Kreta',
      image_url: 'https://images.unsplash.com/photo-1764163863603-0a158f6fdcbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxncmVlY2UlMjBzYW50b3JpbmklMjBzdW5zZXQlMjBjYWxkZXJhJTIwZHJhbWF0aWN8ZW58MHx8fHwxNzc2Mzc1Nzc3fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'spanje',
      naam: 'Spanje',
      dagen: 14,
      prijs: 750,
      hoogtepunten: ['🏛️ Sagrada Familia', '🍷 Tapas & Wijn', '💃 Flamenco Show', '🏖️ Middellandse Zee'],
      beschrijving: 'Barcelona, Madrid, Valencia, Sevilla, Malaga',
      image_url: 'https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'portugal',
      naam: 'Portugal',
      dagen: 14,
      prijs: 800,
      hoogtepunten: ['🏰 Historische Kastelen', '🍷 Porto Wijnproeven', '🏖️ Algarve Stranden', '🚋 Tram 28'],
      beschrijving: 'Porto, Lissabon, Algarve, Faro, Tavira',
      image_url: 'https://images.unsplash.com/photo-1528832135837-894ea33b2f50?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'tunesie',
      naam: 'Tunesië',
      dagen: 11,
      prijs: 600,
      hoogtepunten: ['🏜️ Sahara Woestijn', '🐪 Kamelen Safari', '🏛️ Romeinse Ruïnes', '🏖️ Djerba Eiland'],
      beschrijving: 'Tunis, Sidi Bou Said, Hammamet, Sousse, Sahara Douz, Djerba',
      image_url: 'https://images.unsplash.com/photo-1726428977637-ba8fc5a5047d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHx0dW5pc2lhJTIwc2lkaSUyMGJvdSUyMHNhaWR8ZW58MHx8fHwxNzc2Mzc0NTk4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'marokko',
      naam: 'Marokko',
      dagen: 13,
      prijs: 900,
      hoogtepunten: ['🕌 Marrakech Medina', '🏔️ Atlasgebergte', '🏜️ Sahara Kamptocht', '🎨 Blauwe Stad Chefchaouen'],
      beschrijving: 'Marrakech, Atlasgebergte, Sahara, Fez, Essaouira',
      image_url: 'https://images.unsplash.com/photo-1602859790151-845f2023bee8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb3JvY2NvJTIwc2FoYXJhJTIwZGVzZXJ0JTIwZHVuZXMlMjBzdW5zZXQlMjBkcmFtYXRpY3xlbnwwfHx8fDE3NzYzNzU3OTB8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'turkije',
      naam: 'Turkije',
      dagen: 12,
      prijs: 800,
      hoogtepunten: ['🎈 Cappadocië Ballonvaart', '🕌 Blauwe Moskee', '🏛️ Efeze Ruïnes', '🏖️ Turkse Rivièra'],
      beschrijving: 'Istanbul, Cappadocië, Antalya',
      image_url: 'https://images.unsplash.com/photo-1609519831012-b88942832cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0dXJrZXklMjBjYXBwYWRvY2lhJTIwYmFsbG9vbnxlbnwwfHx8fDE3NzYzNzQ1OTh8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'georgie',
      naam: 'Georgië',
      dagen: 12,
      prijs: 900,
      hoogtepunten: ['🏔️ Kaukasus Bergen', '🍷 Wijnregio Bezoeken', '⛪ Historische Kerken', '🥟 Georgische Cuisine'],
      beschrijving: 'Tbilisi, Kazbegi, Kakheti, Batumi',
      image_url: 'https://images.unsplash.com/photo-1594766722982-fb4cd139ee7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnZW9yZ2lhJTIwa2F6YmVnaSUyMGNodXJjaCUyMG1vdW50YWlucyUyMGVwaWN8ZW58MHx8fHwxNzc2Mzc1NzkwfDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'ierland',
      naam: 'Ierland',
      dagen: 13,
      prijs: 1000,
      hoogtepunten: ['🏰 Middeleeuwse Kastelen', '🌊 Cliffs of Moher', '🍺 Irish Pubs', '🏞️ Ring of Kerry'],
      beschrijving: 'Dublin, Galway, Cliffs of Moher, Ring of Kerry, Kilkenny',
      image_url: 'https://images.unsplash.com/photo-1641129607269-a1d0c0e8a418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxpcmVsYW5kJTIwY2xpZmZzJTIwbW9oZXJ8ZW58MHx8fHwxNzc2Mzc0NTk4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'kroatie-bosnie',
      naam: 'Kroatië & Bosnië',
      dagen: 15,
      prijs: 950,
      hoogtepunten: ['🏖️ Adriatische Kust', '💧 Plitvice Watervallen', '🏛️ Dubrovnik Oude Stad', '🌉 Mostar Brug'],
      beschrijving: 'Zagreb, Plitvice, Zadar, Split, Dubrovnik, Mostar, Sarajevo',
      image_url: 'https://images.unsplash.com/photo-1626699848008-7e419bc4e237?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'albanie-montenegro',
      naam: 'Albanië & Montenegro',
      dagen: 16,
      prijs: 800,
      hoogtepunten: ['🏖️ Albanese Rivièra', '🏔️ Bergwandelingen', '⛵ Kotor Bay', '🏛️ UNESCO Steden'],
      beschrijving: 'Tirana, Berat, Sarande en Ksamil, Albanese Alpen, Shkoder, Durmitor National Park, Kotor',
      image_url: 'https://images.unsplash.com/photo-1504972738139-adc5cfcf91c8?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'baltische-staten',
      naam: 'Baltische Staten',
      dagen: 16,
      prijs: 900,
      hoogtepunten: ['🏰 Middeleeuwse Steden', '🌲 Natuur & Bossen', '🏖️ Oostzeekust', '🎨 Baltische Cultuur'],
      beschrijving: 'Vilnius, Trakai, Klaipeda en Koerse Schoorwal, Riga, Gauja National Park, Tallinn, Kust',
      image_url: 'https://images.unsplash.com/photo-1579795231866-c7c7409e4f10?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    }
  ]
};
